<template><VaIcon name="admin_panel_settings" class="pr-1" size="large" />관리자페이지</template>

<script setup></script>
